import { render, staticRenderFns } from "./CRTag.vue?vue&type=template&id=651a3443&scoped=true"
import script from "./CRTag.vue?vue&type=script&lang=js"
export * from "./CRTag.vue?vue&type=script&lang=js"
import style0 from "./CRTag.vue?vue&type=style&index=0&id=651a3443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a3443",
  null
  
)

export default component.exports